import React from 'react'; // Required by r2wc for the component
import ReactDOM from 'react-dom/client'; // Required by r2wc
import r2wc from '@r2wc/react-to-web-component';
import { ChatWidget } from './components/ChatWidget'; // Import the React component
import './input.css'; // Import styles needed by the component

// Define the Web Component using r2wc
// Props are mapped from kebab-case attributes to camelCase React props
const LumiChatWidgetWC = r2wc(ChatWidget, {
  props: {
    // Define the React prop names and their expected attribute types
    organisationId: "string", // Corresponds to organisation-id attribute
    baseUrl: "string",        // Corresponds to base-url attribute
    // Add other props from ChatWidgetProps here if they should be configurable via attributes
  }
  // Newer r2wc versions might infer React/ReactDOM, but explicitly including them is safer for standalone builds.
  // react: React, // Uncomment if needed
  // ReactDOM: ReactDOM // Uncomment if needed
});

// Register the custom element
// Ensure the tag name is unique and follows custom element naming conventions (must contain a hyphen)
if (!customElements.get('lumi-chat-widget')) {
  customElements.define('lumi-chat-widget', LumiChatWidgetWC);
}